import _ from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { check } from '../../../Utils/FormCalls';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import TableView from '../../../Widgets/TableView';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import { Form, message, Select, Input, Modal,Button } from 'antd';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { PaperClipOutlined, SearchOutlined, DownOutlined } from '@ant-design/icons';
import {
  StyledBox,
  StyledSubHeading
} from '../../../CSS/style';
import {
  getSitesList,
  submitMaster,
  // getHierarchyList,
  // getDeviceList,
  getMasterById
} from '../../../Utils/FormCalls';
import {
  API_DEVICE,
  // API_HIERARCHYMODULE,
  API_MASTERTOOL,
  API_PARAMETER
} from '../../../../../commons/api';
import dayjs from 'dayjs';

const { Option } = Select;
const urlList = {
  insert: API_MASTERTOOL.INSERT,
  getbyId: API_MASTERTOOL.GetById
};
const type = 'Tools';
const fileData = new FormData();

const ToolsDetails = (props) => {
  const [sitesList, setSitesList] = useState([]);
  // const [deviceList, setDeviceList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  // const [hierarchyList, setHierarchyList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [datasource, setDatasource] = useState(props.formObject && props.formObject.Specifications ? props.formObject.Specifications : [{}]);
  const [DeviceAlias, setDeviceAlias] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const ToolsRef = useRef();
  const searchInput = useRef(null);

  const columns = [
    {
      title: translation(props.translationCache, constant.name),
      key: 'Name',
      dataIndex: 'Name',
      widget: 'input',
      required: true
    },
    {
      title: translation(props.translationCache, constant.value),
      key: 'Value',
      dataIndex: 'Value',
      widget: 'inputNumber',
      required: true
    },
    {
      title: translation(props.translationCache, constant.unitOfMeasure),
      key: 'UOM',
      dataIndex: 'UOM',
      widget: 'select',
      required: true,
      table: {
        url: `${API_PARAMETER.GetUOM}`,
        method: 'GET'
      }
    }
  ];

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        const sites = await getSitesList();
        let formObj = ToolsRef.current.getFieldsValue();
        formObj = {
          ...formObj,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        ToolsRef.current.setFieldsValue(formObj);
        setSitesList(sites);
        setFormObject(formObj);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      // try {
      //   const devices = await getDeviceList();
      //   setDeviceList(devices);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
      // try {
      //   const hierarchies = await getHierarchyList();
      //   setHierarchyList(hierarchies);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (ToolsRef.current) ToolsRef.current.setFieldsValue(props.formObject);
    }

    if (props.formObject && props.formObject !== formObject) {
      setFormObject(props.formObject);
      setDatasource(props.formObject.Specifications || [{}]);
    }
    if (props.location !== props.location) {
      onReset();
      _getDataById();
    }
  }, [props]);

  const _getDataById = async (ToolId) => {
    let formObj = {};
    let path = props.location.pathname.split('/rubus/AMM/ToolsDetails/');
    let formId = ToolId ? ToolId : base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getMasterById(urlList.getbyId, formId, 'GET');
      formObj = data || {};
      _.cloneDeepWith(data, (value) => {
        return value && value.StartTime && value.EndTime
          ? {
            ...value,
            StartTime: dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss'),
            EndTime: dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss')
          }
          : _.noop();
      });
    }
    if (ToolsRef.current) {
      ToolsRef.current.setFieldsValue(formObj);
    }
    setFormObject(formObj);
    setDatasource(formObj.Specifications);
    setDeviceAlias(formObj.DeviceAlias);
  };

  const handleChange = async (value, key) => {
    let formObj = ToolsRef.current.getFieldsValue();
    formObj = {
      ...formObj,
      [key]: value
    };
    if (ToolsRef.current) {
      ToolsRef.current.setFieldsValue(formObj);
    }
    setFormObject(formObj);
    if (key === 'DeviceAlias') setDeviceAlias(value);
  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObj = ToolsRef.current.getFieldsValue();
    if (formObj[key]) {
      formObj[key].push(...values);
    } else {
      formObj[key] = values;
    }
    formObj[key] = formObj[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      return x ? acc : acc.concat([current]);
    }, []);
    formObj = {
      ...formObj,
      Specifications: datasource,
      [key]: formObj[key]
    };
    fileData.append('files', fileDataObject);
    if (ToolsRef.current) ToolsRef.current.setFieldsValue(formObj);
    setFormObject(formObj);
  };

  const onFormsubmit = async (values) => {
    let Specifications = [];
    let userId = props.userProfile?.user?.Id || '';
    let SpecificationsForm = formObject.Specifications || [];
    if (Array.isArray(SpecificationsForm)) {
      let editableList = SpecificationsForm.filter((specifi) => specifi.editable);
      if (editableList.length === 0) {
        Specifications = SpecificationsForm.map((spec) => {
          delete spec.editable;
          delete spec.key;
          return spec;
        });
        let payload = {
          ...formObject,
          ...values,
          ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
          ...(formObject && formObject.Id ? { UpdatedBy: userId } : {}),
          Specifications,
          Equipment: DeviceAlias
        };
        let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
        if (statusResponse?.message) {
          _getDataById(statusResponse.Id);
          message.success(statusResponse.message);
          props.navigate('/rubus/AMM/ToolsList');
        } else if (statusResponse?.Error) {
          message.error(statusResponse.Error);
        }
      } else {
        message.warning('Please save specifications before submitting');
      }
    }
  };

  const onReset = () => {
    if (ToolsRef.current) ToolsRef.current.resetFields();
  };

  const saveTableViewData = (datasource) => {
    let formObj = ToolsRef.current.getFieldsValue();
    formObj = {
      ...formObj,
      Specifications: datasource
    };
    setFormObject(formObj);
    setDatasource(datasource);
  };

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then(({ data }) => {
        setTableData(data); // Assuming you have a state variable for tableData
        setFormObject(ToolsRef.current.getFieldsValue()); // Update formObject state
        setVisible(true);
        // setKeyState(key, true); // Assuming you have a function to set the state for the key
      })
      .catch((error) => {
        console.error(error); // Handle error appropriately
      });
  };
  const TableDropdownChange = (value) => {
    // Get the current form values using the ref
    let formObj = ToolsRef.current.getFieldsValue();

    // Update the form object with the new values
    formObj = {
      ...formObj,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode
    };

    // Set the updated form values back to the form
    if (ToolsRef.current) {
      ToolsRef.current.setFieldsValue(formObj);
    }

    // Update the state with the new form object and close the modal
    setFormObject(formObj);
    setDeviceAlias(value?.AliasCode);
    setVisible(false); // Assuming 'visible' is the state variable for the modal
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
 const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 
  return (
    <>
      <Form
        name="Item"
        ref={ToolsRef}
        initialValues={formObject}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          }
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type='primary' htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.tool)}
              name="Tool"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Tool')}
                disabled={formObject && formObject.Id ? true : false}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.toolDescription)}
              name="Description"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Description')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <Input
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Equipment')}
                disabled={true}
                suffix={
                  <DownOutlined
                    style={{
                      color: formObject && formObject.Id ? null : '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData();
                        setVisible(true);
                      }
                    }}
                  />
                }
              />
            </Form.Item>
            <Modal
              open={visible}
              width={800}
              closable
              title={translation(translationCache, constant.selectEquipment)}
              onOk={() => setVisible(false)}
              onCancel={() => setVisible(false)}
            >
              <TableSelect
                data={tableData}
                translationCache={props.translationCache}
                key="Equipment"
                columns={[
                  {
                    title: translation(translationCache, 'Equipment'),
                    dataIndex: 'DisplayCode',
                    key: 'DisplayCode',
                    ...getColumnSearchProps('DisplayCode')
                  },
                  {
                    title: translation(translationCache, 'Equipment Description'),
                    dataIndex: 'Name',
                    key: 'Name',
                    ...getColumnSearchProps('Name')
                  }
                ]}
                handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
              />
            </Modal>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Autopopulated based on Equipment!')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                disabled={formObject && formObject.Id ? true : false}
                placeholder={translation(translationCache, 'Select Site')}
                onChange={(e) => handleChange(e, 'SiteId')}
              >
                {sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              name="Attachments"
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {translation(translationCache, constant.attachments)}
                    <PaperClipOutlined className="plusCircleOutlined" />
                  </span>
                </div>
              }
            >
              <input style={{ width: '70%', display: 'none' }} />
              <FileBase64
                downloadClassName={'formdownloadInput'}
                Attachments={formObject.Attachments}
                fileUpload={fileupload}
              />
            </Form.Item>
          </StyledBox>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.issueUnit)}
              name="IssueUnit"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Issue Unit')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.relatedEquipment)}
              name="RelatedEquipment"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Related Equipment')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.toolName)}
              name="ToolName"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input ToolName')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.drawings)}
              name="Drawings"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Drawings')}
              />
            </Form.Item>
          </StyledBox>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.storeLocation)}
              name="StoreLocation"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Store Location')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(translationCache, constant.Remarks)}
              name="Remarks"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Remarks')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.Quantity)}
              name="AvailableQuantity"
              rules={[
                { required: true },
                {
                  validator: (_, value) => check(value, 'Item', { validateDecimal: true })
                }
              ]}
            >
              <InputNumberComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Input Quantity')}
                onChange={(e) => handleChange(e, 'Quantity')}
              />
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }}>
              <InputComponent style={{ display: 'none' }} />
            </Form.Item>
          </StyledBox>
        </div>

        <StyledSubHeading>
          {translation(translationCache, constant.specifications)}
        </StyledSubHeading>
        <Form.Item>
          <TableView
            form={{ columns: columns, datasource: datasource }}
            saveTableViewData={saveTableViewData}
            showAddButton={true}
          />
        </Form.Item>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile
  };
};

export default connect(mapStateToProps)(ToolsDetails);